module.exports = __webpack_public_path__ + "img/9788949171111.80b16ade.jpg";